var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-container"},[_c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('nuxt')],1),_vm._v(" "),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }